/* RESPONSIBLE TEAM: team-phone */
import { helper as buildHelper } from '@ember/component/helper';
import displayAdminAs from 'embercom/lib/inbox/display-admin-as';

export default buildHelper(function (params) {
  return displayAdminAs(params[0], params[1], true, false, false);
});
